import React, { useState, useEffect, useRef, useCallback } from "react";
import { Line } from "react-chartjs-2";
import { useNavigate, useLocation } from "react-router-dom";
import Dropdown from "../../Components/CustomDropdown/customdropdown";
import { useDispatch } from "react-redux";
import { resetSelectedUsers } from "../../Redux/store/selectedUserSlice";
import { resetDocumentId } from "../../Redux/store/documentSlice";
import DropdownTest from "../Create-Investment/ndrop";
import { svgLogoBase64 } from "../../Constants/config";
import { useToast } from "../../Utils/toastContext";
import { debounce } from "lodash";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
} from "chart.js";
ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale
);
const shadowPlugin = {
  id: "shadowPlugin",
  beforeDraw: (chart) => {
    const ctx = chart.ctx;
    ctx.save();
    ctx.shadowColor = "rgba(52, 192, 70, 0.8)";
    ctx.shadowBlur = 15;
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 10;
  },
  afterDraw: (chart) => {
    const ctx = chart.ctx;
    ctx.restore();
  },
};
const ProductApproval = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const [filter, setFilter] = useState("");
  const [showRecords, setShowRecords] = useState(10);
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState("Download Report");
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, settotalCount] = useState(0);
  const [filterType, setFilterType] = useState("date");
  const [annualDividendFilter, setAnnualDividendFilter] = useState("1Y");
  const [performanceFilter, setPerformanceFilter] = useState("1Y");
  const [filterText, setFilterText] = useState("minimum_investment");
  const navigate = useNavigate();
  const [isOpenStatus, setisOpenStatus] = useState(false);
  const [status, setStatus] = useState("");
  const [isHidden, setIsHidden] = useState(false); // Initially hidden
  const [pdfData, setPdfData] = useState([]); // Initially hidden
  const [loading, setLoading] = useState(false);
  const DownloadDocRef = useRef();
  const today = new Date();
  const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(
    today.getMonth() + 1
  ).padStart(2, "0")}-${today.getFullYear()}`;

  const dropdownRef = useRef();
  const buttonRefs = useRef({});
  const filterOptions = [
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 30, label: "30" },
    { value: 50, label: "50" },
  ];
  const AllStatus = [
    { label: "Active", value: "active" },
    { label: "Rejected", value: "rejected" },
  ];
  const handleDropdownToggle = (id) => {
    // Toggle dropdown for the specific row
    if (openDropdown === id) {
      setOpenDropdown(null); // Close if already open
    } else {
      setOpenDropdown(id); // Open the dropdown for the specific row
    }
  };
  const [openDropdown, setOpenDropdown] = useState(null);

  const [preSelectedFilter, setpreSelectedFilter] = useState({
    value: 7,
    label: "10",
  });
  const handleFilterChange = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setShowRecords(parseInt(selectedOption.value));
    setCurrentPage(1);
  };
  const [data, setData] = useState(null);
  const [filteredData, setfilteredData] = useState(null);
  const [totalPages, settotalPages] = useState(0);

  const [isLoading, setIsLoading] = useState(true);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [tooltipData, setTooltipData] = useState(null);
  const [showTooltip, setShowTooltip] = useState(true);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });

  const handleMouseEnter = (event, strategyGrowth) => {
    const rect = event.target.getBoundingClientRect();
    const isMobile = window.outerWidth < 768;
    if (window.innerWidth < 768) return;

    setTooltipData(strategyGrowth);

    setTooltipPosition({
      top: rect.top + window.scrollY + rect.height / 2 - 50,
      left: rect.left - 260,
    });
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setTooltipData(null);
    setShowTooltip(false);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click happened outside all dropdowns
      const isOutside = !Object.values(buttonRefs.current).some((ref) =>
        ref?.contains(event.target)
      );

      if (isOutside) {
        setOpenDropdown(null); // Close dropdown if clicked outside
      }
      if (
        DownloadDocRef.current &&
        !DownloadDocRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);
  const GetInvestmentList = async () => {
    setIsLoading(true);
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}/v1/investment-portfolio/all?status=${
      filter == "" ? "active,pending" : filter
    }&name=${searchQuery}&sort_by=${filterText}&sort_order=${
      sortConfig.direction
    }&size=${showRecords}&page=${currentPage}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const GetInvestmentListForPdf = async () => {
    const token = localStorage.getItem("jwtToken");

    let apiUrl = `${BASE_URL}/v1/investment-portfolio/all?status=${
      filter == "" ? "active,pending" : filter
    }&name=${searchQuery}&sort_by=${filterText}&sort_order=${
      sortConfig.direction
    }&size=100`;

    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const getAll = async () => {
    try {
      const response = await GetInvestmentList();

      if (response.status == 200) {
        setData(response.data.investments);
        setfilteredData(response.data.investments);
        settotalPages(response.data.total_pages);
        settotalCount(response.data.total_count);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        setfilteredData([]);
        showToast(response.message, "error");
      }
    } catch (err) {
      showToast(err.message, "error");
      setfilteredData([]);
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  const options = [
    { value: "pdf", label: "PDF" },
    { value: "excel", label: "Excel" },
  ];

  const handleSort = (key) => {
    setFilterText(key);
    const direction = sortConfig.direction === "asc" ? "desc" : "asc";
    setSortConfig({ key: null, direction });
  };
  const UpdateStatusCall = async (option, rowId) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    const apiUrl = `${BASE_URL}/v1/investment-portfolio/status/${rowId}`;
    const bodyData = {
      status: option.value,
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const handleStatusChange = async (e, option, rowId) => {
    e.preventDefault();

    try {
      const response = await UpdateStatusCall(option, rowId);
      if (response.status == 200) {
        setStatus(rowId + option.value);
        setisOpenStatus(false);
      } else {
        showToast(response.message, "error");
      }
    } catch (err) {
      showToast(err.message, "error");
    }
  };
  const downloadExcelReport = async () => {
    const token = localStorage.getItem("jwtToken");

    try {
      const response = await fetch(
        `${BASE_URL}/v1/investment-portfolio/all/export/excel?status=${
          filter == "" ? "active,pending" : filter
        }&name=${searchQuery}&size=100&sort_by=${filterText}&sort_order=${
          sortConfig.direction
        }`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        if (response.status === 401) {
          // Optional: clear token and redirect or notify
          localStorage.removeItem("jwtToken");
          navigate("/login");
          // Example: redirect to login page
          // window.location.href = "/login";

          // Or throw a custom error
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.blob();
    } catch (error) {
      throw new Error(error.message || "Something went wrong");
    }
  };
  const downloadPDF = useCallback(
    debounce(async (e, option) => {
      if (option.value == "excel") {
        setLoading(true);
        try {
          const csvBlob = await downloadExcelReport();
          const url = window.URL.createObjectURL(csvBlob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `Investment Portfolios-${formattedDate}.xlsx`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        } catch (err) {
          showToast(err.message, "error");
        } finally {
          setIsOpen(false);
          setTimeout(function () {
            setLoading(false); // Ensure `loading` is false first
          }, 100);
        }
      }
      if (option.value == "pdf") {
        try {
          const response = await GetInvestmentListForPdf();

          if (response.status == 200) {
            if (response.data.investments.length > 0) {
              setPdfData(response.data.investments);
              setIsHidden(true);
            } else {
              setPdfData([]);
              setIsHidden(false);
              setLoading(false); // Ensure `loading` is false first
              showToast("No data available to generate the report.", "error");
            }
          } else {
            setfilteredData([]);
            setLoading(false);
          }
        } catch (err) {
          setPdfData([]);
          showToast(err.message, "error");
          setLoading(false);
        } finally {
          setIsOpen(false);
        }
      }
    }, 1000), // Debounce time
    [filter, filterText, searchQuery, sortConfig] // Dependencies
  );
  function createTableBody() {
    const body = document.createElement("tbody");

    pdfData.forEach((row) => {
      const tr = document.createElement("tr");
      tr.classList.add("tbody-tr");

      tr.innerHTML = `
          <td>${row.ref_id}</td>
          <td class="description">
            <div>Caprock Model Portfolio -</div>
            <div>${row.name}</div>
          </td>
          <td>${row.status}</td>
          <td>${row.strategy_type}</td>
          <td>${row.add_to_dashboard ? "Yes" : "No"}</td>
          <td class="${getColor(
            filterType == "date"
              ? row.strategy_growth.day.value
              : filterType == "month"
              ? row.strategy_growth.month.value
              : row.strategy_growth.month.value
          )}">${
        filterType == "date"
          ? row.strategy_growth.day.value
          : filterType == "month"
          ? row.strategy_growth.month.value
          : row.strategy_growth.year.value
      }%</td>
          <td class="${getColor(
            annualDividendFilter == "1Y"
              ? row.annual_dividend["1year"]
              : annualDividendFilter == "5Y"
              ? row.annual_dividend["5year"]
              : row.annual_dividend["10year"]
          )}">${
        annualDividendFilter == "1Y"
          ? row.annual_dividend["1year"]
          : annualDividendFilter == "5Y"
          ? row.annual_dividend["5year"]
          : row.annual_dividend["10year"]
      }%</td>
          <td class="${getColor(
            performanceFilter == "1Y"
              ? row.performance["1year"]
              : performanceFilter == "5Y"
              ? row.performance["5year"]
              : row.performance["10year"]
          )}">${
        performanceFilter == "1Y"
          ? row.performance["1year"]
          : performanceFilter == "5Y"
          ? row.performance["5year"]
          : row.performance["10year"]
      }%</td>
          <td>${row.no_of_investors}</td>
          <td>${formatValue(row.minimum_investment)}</td>
          <td>${formatValue(row.total_invested)}</td>
        `;
      body.appendChild(tr);
    });
    return body;
  }
  function createTableHeader(columns) {
    const thead = document.createElement("thead");

    // Create thead
    const headRow = document.createElement("tr");
    columns.forEach((col) => {
      const th = document.createElement("th");
      th.textContent = col.label;
      if (col.width) th.style.width = col.width;
      if (col.minWidth) th.style.minWidth = col.minWidth;
      headRow.appendChild(th);
    });
    thead.appendChild(headRow);
    return thead;
  }
  const getColor = (v) => (v > 0 ? "positive" : "negative");

  const formatValue = (value) => {
    return value.toLocaleString(undefined, { minimumFractionDigits: 2 });
  };
  const handleDownloadPDF = async () => {
    const columns = [
      { label: "Ref Id", width: "7rem" },
      { label: "Name", minWidth: "10rem" },
      { label: "Status" },
      { label: "Strategy Type" },
      { label: "Dashboard" },
      { label: "Strategy Growth", width: "10rem" },
      { label: "Annual Dividend" },
      { label: "Performance" },
      { label: "No of Investors" },
      { label: "Min INV Amount" },
      { label: "Total Invested" },
    ];
    const date = new Date().toLocaleString();
    const tableHeadElement = createTableHeader(columns);
    const tableHeader = tableHeadElement.outerHTML;
    const tableBodyElement = createTableBody();
    const tableBody = tableBodyElement.outerHTML;
    const fullHtml = `
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="utf-8" />
          <style>
          @page {
    size: A4 landscape;
    margin: 0;
  }
    html, body {
            margin: 0;
            padding: 0;
                      font-family:sans-serif;
    overflow: auto;  /* Ensure content can overflow */
  
            height: 100%; /* Ensure the body fills the entire height */
          }        .pdf-container {
              max-width: 100% !important;
              margin: 20px;
            }
            tr {
              page-break-inside: avoid !important;
              break-inside: avoid !important;
            }
    
            .custom-header {
              position: relative;
              display: flex;
              justify-content: space-between;
              background-color: #ffffff;
              padding-top: 10px; /* Ensures no padding at the top */
            }
    
            .logo-container {
              display: flex;
              align-items: center;
            }
    
            .logo {
              width: 96px; /* Tailwind w-24 = 6rem = 96px */
              max-width: 150px;
              height: auto;
              object-fit: contain;
              margin-right: 1rem;
            }
    
            .title {
              position: absolute;
              left: 50%;
              transform: translateX(-50%);
              font-size: 1.125rem; /* Tailwind text-lg */
              font-weight: 500;    /* Tailwind font-medium */
              padding: 0;          /* Remove any padding */
              margin: 0;           /* Remove any margin */
            }
    
            .date {
              font-size: 0.875rem;  /* Tailwind text-sm */
              font-weight: 500;
              color: #000000;
              padding-bottom: 16px;
            }
  
    
  .page-break {
           page-break-before: always;
    break-before: page;
    display: block;
    height: 0; /* No extra space */
    width: 100%;
    content: "";}
        table {
        width: 100%;
        border-collapse: collapse;
        table-layout: fixed;
      }
  
      thead {
        font-size: 10px;
        color: #6B7280; /* Tailwind text-labelColour equivalent */
      }
  
      th {
        border-bottom: 1px solid #000;
        padding: 8px;
        text-align: left;
      }
            td {
        padding: 6px;
        font-size: 10px;
        vertical-align: middle;
        text-align: center;
      }
        .tbody-tr{
                    background-color: #F9F9F9;
                    margin-bottom: 10px;
  
        }
      .positive {
        color: #34C046;
      }
      .negative {
        color: #FF5050;
      }
      .description {
        text-align: left;
      }
          </style>
        </head>
        <body>
       <div class="pdf-container">
          <div class="custom-header">
            <div class="logo-container">
              <img src="${svgLogoBase64}" alt="Company Logo" class="logo" />
            </div>
            <h2 class="title">Investment Portfolios</h2>
            <div class="date">${date}</div>
          </div>
          
    <table id="dynamic-table">
    ${tableHeader}
      ${tableBody}
  
    </table>
      
        </div> 
  
             </body>
      </html>
    `;

    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await fetch(
      `${BASE_URL}/v1/investment-portfolio/generate-pdf`,
      {
        method: "POST",
        headers: headers,
        body: JSON.stringify({ html: fullHtml }),
      }
    );
    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
        throw new Error("Session expired. Please log in again.");
      }
      const errorData = await response.json().catch(() => ({
        message: "An unexpected error occurred",
      }));
      throw new Error(errorData.message || "Something went wrong");
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Investment Portfolios-${formattedDate}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setLoading(false);
    setIsHidden(false);
  };
  useEffect(() => {
    if (isHidden == true) {
      handleDownloadPDF();
    }
  }, [isHidden]);
  useEffect(() => {
    getAll();
  }, [
    searchQuery,
    filter,
    showRecords,
    currentPage,
    filterText,
    sortConfig,
    status,
  ]);

  return (
    <div className="min-w-full">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <div className="pt-6 pr-4 flex-wrap items-center">
        <div className="flex mb-2">
          <button
            onClick={() => {
              setCurrentPage(1);
              setSearchQuery("");
              setShowRecords(10);
              setpreSelectedFilter({
                value: 10,
                label: "10",
              });
              setFilter("");
            }}
            className={`px-4 py-2 lg:w-20 rounded-l-xl border-r border-gray-100 ${
              filter === "" ? "bg-black text-white" : "bg-white text-black"
            }`}
          >
            All
          </button>
          <button
            onClick={() => {
              setCurrentPage(1);
              setSearchQuery("");
              setShowRecords(10);
              setpreSelectedFilter({
                value: 10,
                label: "10",
              });
              setFilter("active");
            }}
            className={`lg:px-4 px-2 py-2 border-r border-gray-100 ${
              filter === "active"
                ? "bg-black text-white"
                : "bg-white text-black"
            }`}
          >
            Active
          </button>
          <button
            onClick={() => {
              setCurrentPage(1);
              setSearchQuery("");
              setShowRecords(10);
              setpreSelectedFilter({
                value: 10,
                label: "10",
              });
              setFilter("rejected");
            }}
            className={`px-4 py-2 rounded-r-xl border-r border-gray-100 ${
              filter === "rejected"
                ? "bg-black text-white"
                : "bg-white text-black"
            }`}
          >
            Rejected
          </button>
        </div>
      </div>
      <div className="w-full p-4 bg-white rounded-lg shadow-lg">
        <div className="flex justify-between items-center mb-4 border-b pb-5 border-gray-100">
          <div className="flex items-center">
            <img
              src="/chart-success-black.svg"
              alt="Company Logo"
              className="mr-3"
            />
            <span className="font-medium lg:text-xl text-sm">
              Product Approvals
            </span>
          </div>
        </div>
        <div className="flex justify-between flex-col lg:flex-row flex-wrap mb-4 gap-4 mb-4">
          <div className="flex items-left flex-col lg:flex-row flex-wrap  gap-4 lg:space-x-4 lg:space-y-0 space-x-0">
            <div className="flex items-center space-x-2">
              <span className="lg:text-md  text-sm text-[#8C8C8C]">
                Show Records
              </span>
              <Dropdown
                label=""
                options={filterOptions}
                preselectedValue={preSelectedFilter}
                onSelect={handleFilterChange}
              />
            </div>
            <div className="flex items-center">
              <div className="relative">
                <input
                  type="text"
                  className="p-2 pl-8 border rounded-xl"
                  placeholder="Search Requests"
                  value={searchQuery}
                  onChange={(e) => {
                    setCurrentPage(1);
                    setSearchQuery(e.target.value);
                  }}
                />
                <span className="absolute left-2 top-3 text-gray-500">
                  {" "}
                  <img
                    src="/search-normal.svg"
                    alt="Company Logo"
                    className="mr-2"
                  />
                </span>
              </div>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <div ref={DownloadDocRef} className="relative inline-block ">
              <div
                className="flex justify-between items-center p-3 border border-gray-200 h-11 w-60 rounded-xl cursor-pointer"
                onClick={() => setIsOpen(!isOpen)}
              >
                <img
                  src="/document-download.svg"
                  alt="document-download"
                  className="mr-2"
                />
                <span>{selected}</span>
                <span className="text-gray-500">
                  {" "}
                  <img
                    src="/download-small-arrow.svg"
                    alt="document-download"
                    className=""
                  />
                </span>
              </div>
              {isOpen && (
                <ul className="absolute left-0 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 z-10">
                  {options.map((option) => (
                    <li
                      key={option.value}
                      className="flex items-center p-2 hover:bg-gray-200 cursor-pointer"
                      onClick={(e) => {
                        e.preventDefault();
                        setLoading(true);
                        downloadPDF(e, option);
                      }}
                    >
                      {option.label}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="h-full border border-gray-200">
            <div>
              <thead className="text-[#8C8C8C]  text-sm">
                <tr>
                  <th className="cursor-pointer w-32 font-medium px-4 py-2 border-b text-left">
                    Ref Id
                  </th>
                  <th className="cursor-pointer min-w-64  font-medium px-4 py-2 border-b text-left">
                    Name
                  </th>
                  <th className="cursor-pointer font-medium px-4 py-2 border-b text-left">
                    Status
                  </th>
                  <th className="cursor-pointer font-medium px-4 py-2 border-b text-left">
                    Strategy Type
                  </th>
                  <th className="cursor-pointer font-medium px-4 py-2 border-b text-left">
                    Dashboard
                  </th>
                  <th
                    onClick={() => handleSort("strategy_growth")}
                    className="cursor-pointer font-medium px-4 py-2 w-40 border-b text-left"
                  >
                    <div class="flex items-center">
                      <span> Strategy Growth</span>
                      <img src="/sort.svg" alt="Icon" class="w-4 h-4 ml-2" />
                    </div>
                  </th>
                  <th
                    onClick={() => handleSort("annual_dividend")}
                    className="cursor-pointer font-medium px-4 py-2 border-b text-left"
                  >
                    <div class="flex items-center">
                      <span>Annual Dividend</span>
                      <img src="/sort.svg" alt="Icon" class="w-4 h-4 ml-2" />
                    </div>
                  </th>
                  <th
                    onClick={() => handleSort("performance")}
                    className="cursor-pointer font-medium px-4 py-2 border-b text-left"
                  >
                    <div class="flex items-center">
                      <span>Performance</span>
                      <img src="/sort.svg" alt="Icon" class="w-4 h-4 ml-2" />
                    </div>
                  </th>
                  <th
                    onClick={() => handleSort("no_of_investors")}
                    className="cursor-pointer font-medium px-4 py-2 border-b text-left"
                  >
                    <div class="flex items-center">
                      <span>No of Investors</span>
                      <img src="/sort.svg" alt="Icon" class="w-4 h-4 ml-2" />
                    </div>
                  </th>
                  <th
                    onClick={() => handleSort("minimum_investment")}
                    className="cursor-pointer font-medium px-4 py-2 border-b text-left"
                  >
                    <div class="flex items-center">
                      <span>Min INV Amount</span>
                      <img src="/sort.svg" alt="Icon" class="w-4 h-4 ml-2" />
                    </div>
                  </th>
                  <th
                    onClick={() => handleSort("total_invested")}
                    className="cursor-pointer font-medium px-4 py-2 border-b text-left"
                  >
                    <div class="flex items-center">
                      <span>Total Invested</span>
                      <img src="/sort.svg" alt="Icon" class="w-4 h-4 ml-2" />
                    </div>
                  </th>
                </tr>
              </thead>
              {isLoading ? (
                <tbody className="shimmer-container">
                  {[...Array(5)].map((_, rowIndex) => (
                    <tr key={rowIndex} className="shimmer-row">
                      {[...Array(11)].map((_, colIndex) => (
                        <td key={colIndex} className="shimmer-cell"></td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              ) : (
                <tbody className="text-sm font-medium text-black">
                  <tr key={1} className="border-b-1 ">
                    <td className="px-4  py-2"></td>
                    <td className="px-4 py-2"></td>
                    <td className="px-4 py-2"></td>
                    <td className="px-4 py-2"></td>

                    <td className="px-4 py-2"></td>

                    <td className="pr-5 ">
                      {" "}
                      <div className="flex">
                        {["year", "month", "date"].map((type) => (
                          <button
                            key={type}
                            onClick={() => {
                              setFilterType(type);
                            }}
                            className={`px-3 py-1 font-semibold text-sm  ${
                              filterType === type
                                ? "bg-black text-white"
                                : "bg-[#F9F9F9] text-[#8C8C8C]"
                            }`}
                          >
                            {type.charAt(0).toUpperCase()}
                          </button>
                        ))}
                      </div>
                    </td>
                    <td className=" pr-5">
                      {" "}
                      <div className="flex">
                        {["1Y", "5Y", "10Y"].map((type) => (
                          <button
                            key={type}
                            onClick={() => {
                              setAnnualDividendFilter(type);
                            }}
                            className={`px-3 py-1 font-semibold text-sm  ${
                              annualDividendFilter === type
                                ? "bg-black text-white"
                                : "bg-[#F9F9F9] text-[#8C8C8C]"
                            }`}
                          >
                            {type}
                          </button>
                        ))}
                      </div>
                    </td>
                    <td className=" pr-5">
                      <div className="flex">
                        {["1Y", "5Y", "10Y"].map((type) => (
                          <button
                            key={type}
                            onClick={() => setPerformanceFilter(type)}
                            className={`px-3 py-1 font-semibold text-sm  ${
                              performanceFilter === type
                                ? "bg-black text-white"
                                : "bg-[#F9F9F9] text-[#8C8C8C]"
                            }`}
                          >
                            {type}
                          </button>
                        ))}
                      </div>
                    </td>
                    <td className="px-4 py-2 "></td>
                  </tr>

                  {filteredData.map((row) => (
                    <tr key={row.id} className="mb-2 bg-[#F9F9F9]">
                      <td className="px-4 py-2  ">{row.ref_id}</td>
                      <td
                        onClick={() => {
                          dispatch(resetSelectedUsers());
                          dispatch(resetDocumentId());

                          let redirectState;

                          if (row.status.toLowerCase() === "draft") {
                            redirectState = {
                              path: "/create-investment",
                              state: {
                                from: location.pathname,
                                investment_id: row.id,
                                isNew: false,
                                historyStack: [
                                  ...(location.state?.historyStack || []),
                                  location.pathname,
                                ],
                              },
                            };
                          } else {
                            redirectState = {
                              path: "/investment-details-by-id",
                              state: {
                                from: location.pathname,
                                investment_id: row.id,
                                historyStack: [
                                  ...(location.state?.historyStack || []),
                                  location.pathname,
                                ],
                              },
                            };
                          }

                          // ✅ Save full redirect object to localStorage
                          sessionStorage.setItem(
                            "redirectAfterLogin",
                            JSON.stringify(redirectState)
                          );

                          // Navigate immediately
                          navigate(redirectState.path, {
                            state: redirectState.state,
                          });
                        }}
                        className="underline px-4 py-2 cursor-pointer overflow-hidden w-[800px] text-ellipsis leading-tight"
                      >
                        <span className="block">
                          Caprock Model Portfolio -{" "}
                        </span>
                        <span className="block">{row.name}</span>
                      </td>

                      <td className="px-4 py-2 relative">
                        <button
                          ref={(el) => (buttonRefs.current[`${row.id}`] = el)}
                          disabled={
                            filter == "" && row.status != "approved"
                              ? false
                              : true
                          }
                          onClick={() => handleDropdownToggle(row.id)}
                          className={` w-40  font-medium h-10 rounded-xl text-sm px-2 py-2  flex justify-between items-center focus:outline-none${
                            row.status == "Pending"
                              ? " border-2 border-[#F77E27] text-[#F77E27] bg-[#F1DCCD]"
                              : ""
                          }
                              ${
                                row.status == "Active"
                                  ? " border-2 border-[#34C046] disabled text-[#34C046] bg-[#93DB9C]"
                                  : ""
                              }
                              ${
                                row.status == "Rejected"
                                  ? " border-2 border-[#FF5050] disabled text-[#FF5050] bg-[#E9BDBD]"
                                  : ""
                              }
                              `}
                        >
                          <span className="mr-6">
                            {" "}
                            {row.status.charAt(0).toUpperCase() +
                              row.status.slice(1)}
                          </span>
                          {filter == "" && row.status != "Active" && (
                            <img
                              src={`${
                                openDropdown === row.id
                                  ? "/Vector.svg"
                                  : "/down-grey.svg"
                              }`}
                              alt="Selected"
                              className="w-3 h-3 ml-4"
                            />
                          )}
                        </button>
                        <DropdownTest
                          isOpen={openDropdown === row.id}
                          buttonRef={buttonRefs.current[`${row.id}`]} // Pass unique ref to the dropdown
                        >
                          <div
                            ref={dropdownRef}
                            className="absolute left-0 bg-white rounded-md shadow-lg overflow-hidden z-50 w-full max-w-[200px] border"
                            style={{
                              position: "absolute",
                              top: "100%",
                              left: 0,
                            }}
                          >
                            {AllStatus.map((option) => (
                              <div
                                key={option.value}
                                onClick={(e) =>
                                  handleStatusChange(e, option, row.id)
                                }
                                className={`px-4 py-2 p-3 w-30 mx-2 my-1 text-sm cursor-pointer flex items-center justify-between rounded-xl ${
                                  option.value === "active"
                                    ? "border-2 border-[#34C046] text-[#34C046] bg-[#93DB9C] hover:bg-[#34C046] hover:text-white"
                                    : "border-2 border-[#FF5050] text-[#FF5050] bg-[#E9BDBD] hover:bg-[#FF5050] hover:text-white"
                                }`}
                              >
                                <span>{option.label}</span>
                              </div>
                            ))}
                          </div>
                        </DropdownTest>
                      </td>
                      <td className="px-4 py-2  text-ellipsis  overflow-hidden whitespace-nowrap">
                        <span class="">{row.strategy_type}</span>
                      </td>
                      <td className=" px-4 py-2 text-center text-ellipsis  overflow-hidden whitespace-nowrap">
                        {row.add_to_dashboard === true ? (
                          <span>Yes</span>
                        ) : (
                          <span>No</span>
                        )}
                      </td>
                      <td className="px-4 py-2 ">
                        <div class="flex items-center">
                          {filterType == "date" && (
                            <div>
                              {row.strategy_growth.day.value > 0 ? (
                                <div class="flex items-center">
                                  <img
                                    src="/green-down.svg"
                                    alt="Icon"
                                    class="w-2 h-2 mr-2"
                                  />
                                  <span
                                    className="text-[#34C046] cursor-pointer"
                                    onMouseEnter={(e) =>
                                      handleMouseEnter(e, row.strategy_growth)
                                    }
                                    onMouseLeave={handleMouseLeave}
                                    onHover={(e) =>
                                      handleMouseEnter(e, row.strategy_growth)
                                    }
                                  >
                                    {row.strategy_growth.day.value}%
                                  </span>
                                </div>
                              ) : (
                                <div class="flex items-center">
                                  <img
                                    src="/red-down.svg"
                                    alt="Icon"
                                    class="w-2 h-2 mr-2"
                                  />
                                  <span className="text-[#FF5050]">
                                    {row.strategy_growth.day.value}%
                                  </span>
                                </div>
                              )}
                            </div>
                          )}
                          {filterType == "month" && (
                            <div>
                              {row.strategy_growth.month.value > 0 ? (
                                <div class="flex items-center">
                                  <img
                                    src="/green-down.svg"
                                    alt="Icon"
                                    class="w-2 h-2 mr-2"
                                  />
                                  <span
                                    onMouseEnter={(e) =>
                                      handleMouseEnter(e, row.strategy_growth)
                                    }
                                    onMouseLeave={handleMouseLeave}
                                    onHover={(e) =>
                                      handleMouseEnter(e, row.strategy_growth)
                                    }
                                    className="text-[#34C046] cursor-pointer"
                                  >
                                    {row.strategy_growth.month.value}%
                                  </span>
                                </div>
                              ) : (
                                <div class="flex items-center">
                                  <img
                                    src="/red-down.svg"
                                    alt="Icon"
                                    class="w-2 h-2 mr-2"
                                  />
                                  <span className="text-[#FF5050]">
                                    {row.strategy_growth.month.value}%
                                  </span>
                                </div>
                              )}
                            </div>
                          )}
                          {filterType == "year" && (
                            <div>
                              {row.strategy_growth.year.value > 0 ? (
                                <div class="flex items-center">
                                  <img
                                    src="/green-down.svg"
                                    alt="Icon"
                                    class="w-2 h-2 mr-2"
                                  />
                                  <span
                                    onMouseEnter={(e) =>
                                      handleMouseEnter(e, row.strategy_growth)
                                    }
                                    onMouseLeave={handleMouseLeave}
                                    onHover={(e) =>
                                      handleMouseEnter(e, row.strategy_growth)
                                    }
                                    className="text-[#34C046] cursor-pointer"
                                  >
                                    {row.strategy_growth.year.value}%
                                  </span>
                                </div>
                              ) : (
                                <div class="flex items-center">
                                  <img
                                    src="/red-down.svg"
                                    alt="Icon"
                                    class="w-2 h-2 mr-2"
                                  />
                                  <span className="text-[#FF5050]">
                                    {row.strategy_growth.year.value}%
                                  </span>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </td>
                      <td className="px-4 py-2 text-center ">
                        <div class="flex items-center">
                          {annualDividendFilter == "1Y" && (
                            <div>
                              {row.annual_dividend["1year"] > 0 ? (
                                <div class="flex items-center">
                                  <span className="text-[#34C046]">
                                    {row.annual_dividend["1year"]}%
                                  </span>
                                </div>
                              ) : (
                                <div class="flex items-center">
                                  <span className="text-[#FF5050]">
                                    {row.annual_dividend["1year"]}%
                                  </span>
                                </div>
                              )}
                            </div>
                          )}
                          {annualDividendFilter == "5Y" && (
                            <div>
                              {row.annual_dividend["5year"] > 0 ? (
                                <div class="flex items-center">
                                  <span className="text-[#34C046]">
                                    {row.annual_dividend["5year"]}%
                                  </span>
                                </div>
                              ) : (
                                <div class="flex items-center">
                                  <span className="text-[#FF5050]">
                                    {row.annual_dividend["5year"]}%
                                  </span>
                                </div>
                              )}
                            </div>
                          )}
                          {annualDividendFilter == "10Y" && (
                            <div>
                              {row.annual_dividend["10year"] > 0 ? (
                                <div class="flex items-center">
                                  <span className="text-[#34C046]">
                                    {row.annual_dividend["10year"]}%
                                  </span>
                                </div>
                              ) : (
                                <div class="flex items-center">
                                  <span className="text-[#FF5050]">
                                    {row.annual_dividend["10year"]}%
                                  </span>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </td>
                      <td className="px-4 py-2 text-center ">
                        <div class="flex items-center">
                          {performanceFilter == "1Y" && (
                            <div>
                              {row.performance["1year"] > 0 ? (
                                <div class="flex items-center">
                                  <span className="text-[#34C046]">
                                    {row.performance["1year"]}%
                                  </span>
                                </div>
                              ) : (
                                <div class="flex items-center">
                                  <span className="text-[#FF5050]">
                                    {row.performance["1year"]}%
                                  </span>
                                </div>
                              )}
                            </div>
                          )}
                          {performanceFilter == "5Y" && (
                            <div>
                              {row.performance["10year"] > 0 ? (
                                <div class="flex items-center">
                                  <span className="text-[#34C046]">
                                    {row.performance["10year"]}%
                                  </span>
                                </div>
                              ) : (
                                <div class="flex items-center">
                                  <span className="text-[#FF5050]">
                                    {row.performance["10year"]}%
                                  </span>
                                </div>
                              )}
                            </div>
                          )}
                          {performanceFilter == "10Y" && (
                            <div>
                              {row.performance["since_inception"] > 0 ? (
                                <div class="flex items-center">
                                  <span className="text-[#34C046]">
                                    {row.performance["since_inception"]}%
                                  </span>
                                </div>
                              ) : (
                                <div class="flex items-center">
                                  <span className="text-[#FF5050]">
                                    {row.performance["since_inception"]}%
                                  </span>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </td>
                      <td className="px-4 py-2 text-center ">
                        {row.no_of_investors}
                      </td>
                      <td className="px-4 py-2 text-center">
                        $
                        {row.minimum_investment
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </td>
                      <td className="px-4 py-2 text-center">
                        $
                        {row.total_invested
                          .toFixed(2)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </td>
                    </tr>
                  ))}
                </tbody>
              )}
            </div>
          </table>
          {showTooltip && tooltipData && (
            <div
              className="absolute bg-white text-white rounded shadow-lg p-4"
              style={{
                top: `${tooltipPosition.top}px`,
                left: `${tooltipPosition.left}px`,
                zIndex: 1000,
              }}
            >
              <Line
                options={{
                  responsive: true,
                  maintainAspectRatio: false,
                  elements: {
                    line: {
                      fill: true,
                    },
                  },
                  plugins: {
                    legend: { display: false },
                  },
                  scales: {
                    x: {
                      grid: { display: false },
                      ticks: { display: false },
                      border: { display: false },
                    },
                    y: {
                      grid: { display: false },
                      ticks: { display: false },
                      border: { display: false },
                    },
                  },
                }}
                data={{
                  labels:
                    filterType == "date"
                      ? tooltipData.day.graph_data.map((entry) =>
                          new Date(entry.timestamp).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                          })
                        )
                      : filterType == "month"
                      ? tooltipData.month.graph_data.map((entry) =>
                          new Date(entry.timestamp).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                          })
                        )
                      : tooltipData.year.graph_data.map((entry) =>
                          new Date(entry.timestamp).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                          })
                        ),
                  datasets: [
                    {
                      label: "Growth",
                      data:
                        filterType == "date"
                          ? tooltipData.day.graph_data.map(
                              (entry) => entry.value
                            )
                          : filterType == "month"
                          ? tooltipData.month.graph_data.map(
                              (entry) => entry.value
                            )
                          : tooltipData.year.graph_data.map(
                              (entry) => entry.value
                            ),
                      fill: "start",
                      backgroundColor: "rgba(52, 192, 70, 0.2)",
                      borderColor: "#34C046",
                      borderWidth: 3,
                      tension: 0.4,
                      pointRadius: 0,
                      shadowColor: "rgba(0, 0, 0, 0.2)",
                      shadowBlur: 20,
                      shadowOffsetX: 0,
                      shadowOffsetY: 10,
                    },
                  ],
                }}
                plugins={[shadowPlugin]}
                height={50}
                width={200}
              />
              <div
                className="absolute right-0 top-1/2 transform -translate-y-1/2 -mr-2 w-0 h-0"
                style={{
                  borderTop: "8px solid transparent",
                  borderBottom: "8px solid transparent",
                  borderLeft: "8px solid white",
                }}
              ></div>
            </div>
          )}
        </div>
        {filteredData != null && (
          <div className="flex flex-wrap justify-between items-center mt-4 space-y-4 sm:space-y-0">
            {/* Entries Info Section */}
            <div className="text-[#8C8C8C] text-sm sm:text-base w-full sm:w-auto text-center sm:text-left">
              Showing {showRecords * (currentPage - 1) + 1} to{" "}
              {currentPage === totalPages || totalPages == 0
                ? totalCount
                : Math.max(showRecords * currentPage, filteredData.length)}{" "}
              of {totalCount} entries
            </div>

            {/* Pagination Section */}
            <div className="flex flex-wrap items-center justify-center sm:justify-end font-semibold text-sm gap-2 w-full sm:w-auto">
              {/* Previous Button */}
              <button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((prev) => prev - 1)}
                className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Prev
              </button>

              {/* Page Buttons */}
              {Array.from({ length: Math.min(totalPages, 5) }).map(
                (_, index) => {
                  const startPage = Math.max(
                    1,
                    Math.min(totalPages - 4, currentPage - 2)
                  );
                  const page = startPage + index;

                  return (
                    <button
                      key={page}
                      onClick={() => setCurrentPage(page)}
                      className={`px-3 py-1 rounded ${
                        currentPage === page
                          ? "bg-black text-white"
                          : "bg-white border border-gray-300 text-black"
                      }`}
                    >
                      {page}
                    </button>
                  );
                }
              )}

              {/* Next Button */}
              <button
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((prev) => prev + 1)}
                className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductApproval;
